import script from "./LoadingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingPage.vue?vue&type=script&setup=true&lang=js"

import "./LoadingPage.vue?vue&type=style&index=0&id=709d99a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709d99a6"]])

export default __exports__